var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43821 8.40625C3.23251 8.40625 3.87642 7.77665 3.87642 7C3.87642 6.22335 3.23251 5.59375 2.43821 5.59375C1.64391 5.59375 1 6.22335 1 7C1 7.77665 1.64391 8.40625 2.43821 8.40625Z",
    stroke: "black",
    strokeWidth: 1.05469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1086 4.1875C10.9029 4.1875 11.5468 3.5579 11.5468 2.78125C11.5468 2.0046 10.9029 1.375 10.1086 1.375C9.31432 1.375 8.67041 2.0046 8.67041 2.78125C8.67041 3.5579 9.31432 4.1875 10.1086 4.1875Z",
    stroke: "black",
    strokeWidth: 1.05469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1086 12.625C10.9029 12.625 11.5468 11.9954 11.5468 11.2188C11.5468 10.4421 10.9029 9.8125 10.1086 9.8125C9.31432 9.8125 8.67041 10.4421 8.67041 11.2188C8.67041 11.9954 9.31432 12.625 10.1086 12.625Z",
    stroke: "black",
    strokeWidth: 1.05469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69141 7.68945L8.85518 10.5295M8.85518 3.4707L3.69141 6.31074",
    stroke: "black",
    strokeWidth: 1.05469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1f6eeb83ab43a444c23b93e2cad90e43.svg";
export { ForwardRef as ReactComponent };